var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.countedTicketsConfig),function(config){return _c('li',{key:config.id},[_c('ProviderExpand',{attrs:{"to-route":'/reachout/' + config.id,"providerwise-patient-count":config.patientCount,"total-count":config.patientCount.total.length,"type":"reachout"}},[_vm._v("\n            "+_vm._s(config.title)+"\n        ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }